export default "__VITE_ASSET__OwH3UIeX__"